import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FooterComponent } from '@app/shared/blocks/application/footer/footer.component';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet />
    <app-footer />
  `,
  imports: [RouterOutlet, FooterComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    id: '5e473249-92c3-4cc9-a93a-32bfcf7711b3',
  },
})
export class AppComponent {}
